import { Analytics } from '../../utils/analytics';
import type {
  CeDirectoryFilters,
  CeDirectoryListing,
  CeDirectoryScope,
} from './types';

type DirectoryEvent = 'CE Directory Loaded'
  | 'CE Directory Filter Changed'
  | 'CE Directory Page Loaded'
  | 'CE Directory Listing Clicked';

export function trackCeDirectoryEvent(
  event: DirectoryEvent,
  filters: CeDirectoryFilters,
  options: {
    listing?: CeDirectoryListing;
    effectiveScope?: CeDirectoryScope;
  } = {},
): void {
  const payload: Record<string, string | number> = {
    group: filters.group,
    format: filters.format,
    scope: options.effectiveScope ?? filters.scope,
  };
  if (options.listing) {
    payload.listingId = options.listing.id;
    payload.categoryKey = options.listing.category.key;
  }
  try {
    Analytics.track(event, payload);
  } catch (error) {
    console.warn(`CE directory analytics failed for ${event}`, error);
  }
}
